export default __webpack_public_path__ + "static/media/css_original_wordmark_logo_icon_146576.6eb18ad7.png";